import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const CreditCard: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '32px',
      height: '32px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path d="M4 12.0007H28" stroke="#B4EB56" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.7626 17.3327H9.33594" stroke="#B4EB56" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 25.3327H8C5.79067 25.3327 4 23.542 4 21.3327V10.666C4 8.45668 5.79067 6.66602 8 6.66602H24C26.2093 6.66602 28 8.45668 28 10.666V21.3327C28 23.542 26.2093 25.3327 24 25.3327Z"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export const CreditCardDark: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '32px',
      height: '32px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path d="M4 11.9987H28" stroke="#090C18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.7626 17.3327H9.33594" stroke="#090C18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 25.3327H8C5.79067 25.3327 4 23.542 4 21.3327V10.666C4 8.45668 5.79067 6.66602 8 6.66602H24C26.2093 6.66602 28 8.45668 28 10.666V21.3327C28 23.542 26.2093 25.3327 24 25.3327Z"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
